import Component from '@glimmer/component';
import FunctionalUtils from 'mewe/shared/functional-utils';

export default class Icons extends Component {

  copyCode(e) {
    navigator.clipboard.writeText(e.target.textContent);
    FunctionalUtils.info('Copied to clipboard');
  }

}
